import React from "react";
import { NavLink } from "react-router-dom";

const NavItem = ({ link, icon, menu, setActiveMenu, exact = false, onSelect }) => {
  return (
    <li role="none">
      <NavLink
        to={link}
        end={exact}
        role="menuitem"
        onClick={() => {
          if (typeof setActiveMenu === "function") setActiveMenu(link);
          if (typeof onSelect === "function") onSelect(link);
        }}
        className={({ isActive }) =>
          `flex items-center px-4 py-3 rounded mb-2 text-base font-medium duration-200 ${isActive ? "bg-primary text-white" : "text-body-color hover:bg-primary hover:text-white"
          }`
        }
      >
        <span className="mr-3" aria-hidden="true">
          {icon}
        </span>
        <span>{menu}</span>
      </NavLink>
    </li>
  );
};
export default NavItem;
